import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import './Auth.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const loginResult = await login(email, password);

            // Debug: Log login result to check user data
            console.log('Login result:', loginResult);

            // Check user role and redirect accordingly
            const userRole = loginResult.user?.role;
            console.log('User role after login:', userRole);

            if (userRole === 'admin' || userRole === 'doctor') {
                // Redirect admin/doctor users to admin panel
                console.log('Redirecting to admin panel');
                navigate('/admin', { replace: true });
                return;
            }

            // For regular users, try to restore bookmark after successful login
            try {
                const response = await api.get('/users/me');
                const lastVisitedPath = response.data.user?.lastVisited?.path;

                if (lastVisitedPath && lastVisitedPath.startsWith('/journal/')) {
                    navigate(lastVisitedPath, { replace: true });
                } else {
                    navigate('/dashboard');
                }
            } catch (bookmarkError) {
                // If bookmark fetch fails, just go to dashboard
                console.error('Failed to restore bookmark:', bookmarkError);
                navigate('/dashboard');
            }
        } catch (err) {
            console.error('Login error details:', err);
            console.error('Error response:', err.response?.data);
            console.error('Error message:', err.message);

            // More specific error handling
            if (err.message && err.message.includes('Invalid user data')) {
                setError('Authentication failed: Invalid user data from server');
            } else {
                setError(err.response?.data?.message || err.message || 'Login failed. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h1 className="auth-title">Dr. Within Health Journal</h1>
                <h2 className="auth-subtitle">Sign In</h2>

                {error && (
                    <div className="alert alert-error">{error}</div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter email"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            required
                        />
                    </div>

                    <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
                        {loading ? <div className="spinner"></div> : 'Sign In'}
                    </button>
                </form>

                <div className="auth-footer">
                    <p>Don't have an account? <Link to="/register" className="auth-link">Sign up</Link></p>
                    <p><Link to="/forgot-password" className="auth-link">Forgot Password?</Link></p>
                    <p className='release-version' >Version 0.4.0</p>
                </div>
            </div>
        </div>
    );
};

export default Login;
